export const BACKEND_API_URL = '/api/risk-management';
export const XC_API_URL = '/web/rest-risk-management';
